import * as React from "react"
import { Avatar, AvatarImage, AvatarFallback } from "./avatar"
import { cn } from "../../lib/utils"

const SIZE_CLASSES = {
  xs: "h-10 w-10",
  sm: "h-12 w-12 md:h-14 md:w-14",
  md: "h-16 w-16",
} as const

// "Dr. Marie Koné" -> "MK". Strips the "Dr." prefix so it doesn't end up
// contributing a stray initial.
function getInitials(name?: string): string {
  const parts = (name ?? "").replace(/^Dr\.?\s*/i, "").trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  const first = parts[0][0] ?? ""
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? "" : ""
  return (first + last).toUpperCase()
}

interface TherapistAvatarProps {
  imageUrl?: string
  name?: string
  size?: keyof typeof SIZE_CLASSES
  className?: string
}

// Shared circular therapist photo used everywhere a patient sees a
// therapist's avatar (quick-book bar, intake match cards). Radix's
// AvatarImage automatically swaps to AvatarFallback on a missing src or a
// failed image load, so callers don't need their own `imageUrl &&` guard —
// a broken/404'd photo shows initials instead of a broken-image icon.
export function TherapistAvatar({ imageUrl, name, size = "md", className }: TherapistAvatarProps) {
  return (
    <Avatar className={cn(SIZE_CLASSES[size], "flex-shrink-0", className)}>
      <AvatarImage src={imageUrl} alt={name || "Thérapeute"} className="object-cover" />
      <AvatarFallback className="bg-cyan-50 text-[#00c4cc] font-semibold">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  )
}
